/* esm.sh - applesauce-common@5.2.0/dist/blueprints/torrent */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/torrent.mjs";
